import { useState } from "react";
import Box from "@mui/material/Box";
import { Tab, Tabs, Typography } from "@mui/material";

import typography from "../../cssUtils/typography";
import SummaryTab from "./SummaryTab";
import ResponsesTable from "./ResponsesTable";

export default function SurveyResponsesPage() {
  const [activeTab, setActiveTab] = useState("responses");

  return (
    <Box sx={{ p: 3, bgcolor: "#fafafa" }}>
      <Typography sx={{ ...typography.bodyLarge, fontWeight: 600, fontSize: 20, color: "#1D2330" }}>
        YES SECURITIES — Trading Behaviour Survey
      </Typography>
      <Typography sx={{ ...typography.bodySmall, color: "#6C7C93", mb: 2 }}>
        Win-back / churn feedback from customers who reduced or stopped trading
      </Typography>

      <Tabs value={activeTab} onChange={(event, value) => setActiveTab(value)} sx={{ mb: 2 }}>
        <Tab value="responses" label="Individual Responses" />
        <Tab value="summary" label="Summary" />
      </Tabs>

      {activeTab === "summary" ? <SummaryTab /> : <ResponsesTable />}
    </Box>
  );
}
